import { makeAutoObservable, runInAction } from 'mobx'

import { http } from '@/utils'

class PoliceStore {
    //数据列表初始化
    dataList = [];
    //总条数
    total = '';
    //条数
    limit = 10;
    //当前页
    page = 1;

    //弹框显示
    isAshow = false;
    //弹框状态初始化
    isActive = false
    isJdWd = false

    name = '';
    dqid = '';
    //编辑数据存放
    datas = {};
    valueData = {
        lat: 43,
        lng: 125
    }
    //查看数据
    seevalue = {}
    title = ''

    //搜索规则
    filter = ''
    op = ''

    selectdata = []

    constructor() {
        makeAutoObservable(this)
    }
    getDataList = async (greenHouseId) => {
        const res = await http.get(`/coopapi/device/alarmlist?greenHouseId=${greenHouseId}`)
        if (res.data.Code === 0) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.Data))
            })
        }
    }
    //下拉数据
    newselect = async () => {
        const res = await http.get(`/coopapi/device/getGreenhouseList`)
        if (res.status === 200) {
            res.data.Data.map((item, index) => {
                this.selectdata = this.selectdata.concat({ value: `${item.GreenHouseId + ',' + item.GreenHouseName}`, label: item.GreenHouseName })
            })
        }
    }
}

export { PoliceStore }